import { Component, OnInit, Input, Optional } from '@angular/core';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { OptionService } from '../../services/option.service';

import { ValueControlViewModel, OptionValueChange, OptionItem } from '../../types/control.types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlModelPropertyEnum } from '../../types';

@Component({
  selector: 'df-options-control-base',
  templateUrl: './options-control-base.component.html',
  styleUrls: ['./options-control-base.component.css']
})
export class OptionsControlBaseComponent<T extends OptionItem> extends AbstractValueControlBase<ValueControlViewModel>
  implements OnInit, OptionValueChange {
  @Input() options: Array<T>;
  @Input() displayMember: string = 'text';
  @Input() valueMember: string = 'id';

  /**
   * éé¡¹æ¯å¦å è½½å®æ
   *
   * @memberof OptionsControlBaseComponent
   */
  isOptionLoadComplete: boolean = false;
  /**
   * @description æ¾ç¤ºçéé¡¹
   *
   * @memberof OptionsControlBaseComponent
   */
  showOptions: Array<T>;

  oldValue?: string;

  constructor(protected commonConfig: DynamicFormCommonConfig, @Optional() protected service: OptionService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.optionValueChange();

    // å·æ°æ°æ®
    this.controlShared.globalDataChange.subscribe((s) => {
      this.refreshOptions(false);
    });
  }

  convertOptions() {
    if (!this.options) {
      this.options = [
        { id: `éé¡¹1`, text: `éé¡¹1` },
        { id: `éé¡¹2`, text: `éé¡¹2` },
        { id: `éé¡¹3`, text: `éé¡¹3` }
      ] as T[];
    }
    this.showOptions = this.options;
  }

  optionValueChange(): void {
    this.refreshOptions(true);
  }

  /**
   * å·æ°éé¡¹
   *
   * @param boolean isFirst æ¯å¦ç¬¬ä¸æ¬¡å è½½
   * @memberof OptionsControlBaseComponent
   */
  refreshOptions(isFirst: boolean): void {
    const optionName = ControlModelPropertyEnum.Option;
    if (!this.model[optionName]) {
      this.convertOptions();
      this.loadComplete();
      return;
    }

    const option = this.model[optionName].find((s: any) => s.selected === true);
    if (option.id === 'dataSource') {
      const varValue = this.service.getVarValueByUrl(option.value, this.controlShared.globalData);
      // æ°æ§å¼ç¸åï¼å¹¶ä¸ä¸æ¯ç¬¬ä¸æ¬¡å è½½æ¶ï¼ä¸å·æ°æ°æ®
      if (varValue === this.oldValue && !isFirst) {
        return;
      } else {
        this.oldValue = varValue;
      }
    }
    this.service.getSelectOptionsByProperty(option, this.oldValue, isFirst).subscribe(
      (s) => {
        this.options = s as T[];
        this.convertOptions();
        this.loadComplete();
      },
      (error) => {
        this.commonConfig.log.warn(`è·åæ°æ®å¤±è´¥`);
      }
    );
    return;
  }

  get valid(): boolean {
    if (this.isOptionLoadComplete) {
      return this.getValidState();
    } else {
      return false;
    }
  }

  loadComplete() {
    this.isOptionLoadComplete = true;
    this.setModelValue(this.model.value);
  }
}
